@if (factSheet) {
  @for (data of data; track data) {
    <div class="flex flex-col">
      <h3 class="mt-1 font-bold">{{ data[0] }}</h3>
      <p>{{ data[1] }}</p>
    </div>
  }
}
